/** Civil/business dates are stored as YYYY-MM-DD and never parsed as UTC. */
export function todayBusinessDate(now = new Date()): string {
  return formatBusinessDate(now.getFullYear(), now.getMonth() + 1, now.getDate());
}

export function parseBusinessDate(value: string): { year: number; month: number; day: number } {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!match) throw new Error(`Invalid business date: ${value}`);
  return { year: Number(match[1]), month: Number(match[2]), day: Number(match[3]) };
}

export function formatBusinessDate(year: number, month: number, day: number): string {
  return `${year.toString().padStart(4, '0')}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
}

export function addMonthsToBusinessDate(value: string, months: number): string {
  const { year, month, day } = parseBusinessDate(value);
  const target = new Date(year, month - 1 + months, 1);
  const lastDay = new Date(target.getFullYear(), target.getMonth() + 1, 0).getDate();
  return formatBusinessDate(target.getFullYear(), target.getMonth() + 1, Math.min(day, lastDay));
}

export function addDaysToBusinessDate(value: string, days: number): string {
  const { year, month, day } = parseBusinessDate(value);
  const result = new Date(year, month - 1, day);
  result.setDate(result.getDate() + days);
  return formatBusinessDate(result.getFullYear(), result.getMonth() + 1, result.getDate());
}

export function compareBusinessDates(a: string, b: string): number { return a.localeCompare(b); }
